import {configureStore} from "@reduxjs/toolkit";
import {
  auth,
  home,
  alert,
  modal,
  layout,
  credits,
  clients,
  payments,
  navigation,
  multimedia,
} from "./slices";

export const store = configureStore({
  reducer: {
    home: home["reducer"],
    auth: auth["reducer"],
    alert: alert["reducer"],
    modal: modal["reducer"],
    layout: layout["reducer"],
    clients: clients["reducer"],
    credits: credits["reducer"],
    payments: payments["reducer"],
    navigation: navigation["reducer"],
    multimedia: multimedia["reducer"],
  },
  devTools: process.env.NODE_ENV === "development",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({serializableCheck: false}),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
